import { TimeUnitApi } from 'api-typings/common/common';
import { BenefitDuplicateRuleApi } from 'api-typings/memberships/memberships_types';
import { Package } from '../recommended-membership/recommended-membership.model';

export function generateMembershipPackagesObjects(): readonly Package[] {
  return [
    {
      id: 7,
      internalName: 'plan15',
      displayName: 'intro',
      enabled: false,
      categoryId: 1,
      order: 2000,
      benefits: [
        {
          id: 119,
          benefit: {
            id: 22,
            value: 6,
            displayName: 'Bids Per Month',
            internalName: 'bids_limit',
            duplicateRule: BenefitDuplicateRuleApi.SUM,
          },
          benefitValue: 15,
          packageId: 7,
        },
      ],
      prices: [
        {
          id: 1,
          amount: 0.99,
          contractQuantity: 1,
          currencyId: 1,
          durationId: 1,
          durationType: TimeUnitApi.MONTH,
          durationCycle: 1,
          packageId: 7,
          timeValidStart: Date.now(),
        },
        {
          id: 3602,
          amount: 0.99,
          contractQuantity: 12,
          currencyId: 1,
          durationId: 1,
          durationType: TimeUnitApi.MONTH,
          durationCycle: 1,
          packageId: 7,
          timeValidStart: Date.now(),
        },
        {
          id: 148,
          amount: 11.88,
          contractQuantity: 1,
          currencyId: 1,
          durationId: 10,
          durationType: TimeUnitApi.YEAR,
          durationCycle: 1,
          packageId: 7,
          timeValidStart: Date.now(),
        },
      ],
    },
    {
      id: 2,
      internalName: 'plan20',
      displayName: 'basic',
      enabled: true,
      categoryId: 1,
      order: 3000,
      benefits: [
        {
          id: 5,
          benefit: {
            id: 22,
            value: 6,
            displayName: 'Bids Per Month',
            internalName: 'bids_limit',
            duplicateRule: BenefitDuplicateRuleApi.SUM,
          },
          benefitValue: 50,
          packageId: 2,
        },
      ],
      prices: [
        {
          id: 2,
          amount: 4.95,
          contractQuantity: 1,
          currencyId: 1,
          durationId: 2,
          durationType: TimeUnitApi.MONTH,
          durationCycle: 1,
          packageId: 2,
          timeValidStart: Date.now(),
        },
        {
          id: 3475,
          amount: 4.45,
          contractQuantity: 12,
          currencyId: 1,
          durationId: 2,
          durationType: TimeUnitApi.MONTH,
          durationCycle: 1,
          packageId: 2,
          timeValidStart: Date.now(),
        },
        {
          id: 169,
          amount: 53.4,
          contractQuantity: 1,
          currencyId: 1,
          durationId: 8,
          durationType: TimeUnitApi.YEAR,
          durationCycle: 1,
          packageId: 2,
          timeValidStart: Date.now(),
        },
      ],
    },
    {
      id: 5,
      internalName: 'plan25',
      displayName: 'plus',
      enabled: true,
      categoryId: 1,
      order: 4000,
      benefits: [
        {
          id: 91,
          benefit: {
            id: 22,
            value: 6,
            displayName: 'Bids Per Month',
            internalName: 'bids_limit',
            duplicateRule: BenefitDuplicateRuleApi.SUM,
          },
          benefitValue: 100,
          packageId: 5,
        },
      ],
      prices: [
        {
          id: 3,
          amount: 9.95,
          contractQuantity: 1,
          currencyId: 1,
          durationId: 3,
          durationType: TimeUnitApi.MONTH,
          durationCycle: 1,
          packageId: 5,
          timeValidStart: Date.now(),
        },
        {
          id: 3498,
          amount: 8.95,
          contractQuantity: 12,
          currencyId: 1,
          durationId: 3,
          durationType: TimeUnitApi.MONTH,
          durationCycle: 1,
          packageId: 5,
          timeValidStart: Date.now(),
        },
        {
          id: 190,
          amount: 107.4,
          contractQuantity: 1,
          currencyId: 1,
          durationId: 9,
          durationType: TimeUnitApi.YEAR,
          durationCycle: 1,
          packageId: 5,
          timeValidStart: Date.now(),
        },
      ],
    },
    {
      id: 8,
      internalName: 'plan30_1',
      displayName: 'professional',
      enabled: true,
      categoryId: 1,
      order: 5001,
      benefits: [
        {
          id: 154,
          benefit: {
            id: 22,
            value: 6,
            displayName: 'Bids Per Month',
            internalName: 'bids_limit',
            duplicateRule: BenefitDuplicateRuleApi.SUM,
          },
          benefitValue: 300,
          packageId: 8,
        },
      ],
      prices: [
        {
          id: 106,
          amount: 29.95,
          contractQuantity: 1,
          currencyId: 1,
          durationId: 6,
          durationType: TimeUnitApi.MONTH,
          durationCycle: 1,
          packageId: 8,
          timeValidStart: Date.now(),
        },
        {
          id: 3521,
          amount: 24.95,
          contractQuantity: 12,
          currencyId: 1,
          durationId: 6,
          durationType: TimeUnitApi.MONTH,
          durationCycle: 1,
          packageId: 8,
          timeValidStart: Date.now(),
        },
        {
          id: 211,
          amount: 299.4,
          contractQuantity: 1,
          currencyId: 1,
          durationId: 11,
          durationType: TimeUnitApi.YEAR,
          durationCycle: 1,
          packageId: 8,
          timeValidStart: Date.now(),
        },
      ],
    },
    {
      id: 9,
      internalName: 'plan50_1',
      displayName: 'premier',
      enabled: true,
      categoryId: 1,
      order: 6001,
      benefits: [
        {
          id: 958,
          benefit: {
            id: 22,
            value: 6,
            displayName: 'Bids Per Month',
            internalName: 'bids_limit',
            duplicateRule: BenefitDuplicateRuleApi.SUM,
          },
          benefitValue: 700,
          packageId: 9,
        },
      ],
      prices: [
        {
          id: 5039,
          amount: 69.95,
          contractQuantity: 1,
          currencyId: 1,
          durationId: 7,
          durationType: TimeUnitApi.MONTH,
          durationCycle: 1,
          packageId: 9,
          timeValidStart: Date.now(),
        },
        {
          id: 5078,
          amount: 59.95,
          contractQuantity: 12,
          currencyId: 1,
          durationId: 7,
          durationType: TimeUnitApi.MONTH,
          durationCycle: 1,
          packageId: 9,
          timeValidStart: Date.now(),
        },
      ],
    },
  ];
}
